import React, { useCallback, useState } from "react";
import { Card, theme } from "antd";
import useProducts from "./hooks/useProducts";
import useCategories from "./hooks/useCategories";
import useProductFilters from "./hooks/useProductFilters";
import StoreHeader from "./components/StoreHeader";
import ProductFilters from "./components/ProductFilters";
import ProductsTable from "./components/ProductsTable";
import ProductFormModal from "./components/ProductFormModal";

export default function AdminStoreDashboard() {
  const { token } = theme.useToken();
  const { products, loading, reload, remove } = useProducts();
  const { categories } = useCategories();
  const filters = useProductFilters(products);
  const [modal, setModal] = useState({ open: false, product: null });

  const openCreate = useCallback(() => setModal({ open: true, product: null }), []);
  const openEdit = useCallback((product) => setModal({ open: true, product }), []);
  const closeModal = useCallback(() => setModal({ open: false, product: null }), []);

  const handleSaved = () => {
    closeModal();
    reload();
  };

  return (
    <div
      style={{
        padding: "clamp(16px, 4vw, 32px)",
        maxWidth: 1400,
        margin: "0 auto",
        backgroundColor: token.colorBgLayout,
        minHeight: "100vh",
      }}
    >
      <StoreHeader onCreate={openCreate} />

      <Card
        style={{
          borderRadius: token.borderRadiusLG,
          boxShadow: token.boxShadowTertiary,
          border: `1px solid ${token.colorBorderSecondary}`,
        }}
        bodyStyle={{ padding: token.paddingXS }}
      >
        <ProductFilters
          searchTerm={filters.searchTerm}
          onSearchChange={filters.setSearchTerm}
          categories={filters.filterCategories}
          selectedCategories={filters.selectedCategories}
          onCategoriesChange={filters.setSelectedCategories}
        />
        <ProductsTable
          products={filters.filteredProducts}
          loading={loading}
          onEdit={openEdit}
          onDelete={remove}
        />
      </Card>

      <ProductFormModal
        open={modal.open}
        product={modal.product}
        categories={categories}
        onClose={closeModal}
        onSaved={handleSaved}
      />
    </div>
  );
}
